module.exports = __webpack_public_path__ + "img/orange_031.a9f9ebea.png";